import { render } from "./SentenceSlot.vue?vue&type=template&id=3a9184ec&scoped=true"
import script from "./SentenceSlot.vue?vue&type=script&lang=js"
export * from "./SentenceSlot.vue?vue&type=script&lang=js"

import "./SentenceSlot.vue?vue&type=style&index=0&id=3a9184ec&scoped=true&lang=css"

import exportComponent from "D:\\SphinxProjects\\VUE3\\Excel_Library_Frontend_Website\\excel-library-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9184ec"]])

export default __exports__